import {BinIcon} from "../../../../components/icon/Icon.jsx";
import {BonusCardTitleStyled} from "./styled/BonusCardStyled.js";

export const BonusCard = ({children, backgroundColor = 'var(--color-surface-secondary)', color, style}) => (
        <div className="d-flex" style={style}>
            <BinIcon name="IcBonusStub" style={{
                width: '13px',
                height: '24px',
                left: '1px',
                position: 'relative',
                fill: backgroundColor
            }}/>
            <BonusCardTitleStyled backgroundColor={backgroundColor} color={color}>
                <div className="px-1 h-100 d-flex align-items-center">
                    {children}
                </div>
            </BonusCardTitleStyled>
        </div>
)